export const DATA_SET_LAYOUT = 'app/DATA_SET_LAYOUT';
export const GET_PAGE_STATS = 'app/GET_PAGE_STATS';
export const POST_CREATE_SUBSCRIPTION = 'app/POST_CREATE_SUBSCRIPTION';
export const SWITCH_PANEL = 'app/SWITCH_PANEL';



// WEBPACK FOOTER //
// ./src/redux/App/constants.js